import { createSlice, createAction } from '@reduxjs/toolkit';
import {
  fetchCarHouses,
  addCarHouse,
  editCarHouse,
  removeCarHouse,
  addCredit,
  getCreditsHistory,
  fetchCarHouseById,
} from '../actions/carHouse-actions';

export const setCurrentPage = createAction('carHouse/setCurrentPage');
export const setSearchParams = createAction('carHouse/setSearchParams');

const initialState = {
  isLoading: false,
  carHouses: [],
  carHouse: [],
  credits: [],
  total: 0,
  currentPage: 1, // Add currentPage to the state
  perPage: 12, // Add perPage to manage items per page
  searchParams: {}, // Add searchParams to store the search criteria
};

const carHouseSlice = createSlice({
  name: 'carHouse',
  initialState: initialState,
  reducers: {
    setCarHouses(state, action) {
      state.carHouses = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(fetchCarHouses.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchCarHouses.fulfilled, (state, action) => {
        const { carHouses, count } = action.payload;
        state.isLoading = false;
        state.carHouses = carHouses;
        state.total = count;
      })
      .addCase(fetchCarHouses.rejected, (state, action) => {
        //  state.isLoading = false;
      })
      .addCase(addCarHouse.fulfilled, (state, action) => {
        const newCarHouse = action.payload;
        state.carHouses.unshift(newCarHouse);
      })
      .addCase(editCarHouse.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.carHouses.findIndex(
          (carHouse) => carHouse.id === data.id
        );
        if (~index) {
          state.carHouses[index] = data;
        }
      })
      .addCase(removeCarHouse.fulfilled, (state, action) => {
        const carHouseId = action.payload;

        state.carHouses = state.carHouses.filter(
          (carHouse) => carHouse.id !== carHouseId
        );
      })
      .addCase(addCredit.fulfilled, (state, action) => {
        const data = action.payload;
        const index = state.carHouses.findIndex(
          (carHouse) => carHouse.id === data.id
        );
        if (~index) {
          state.carHouses[index] = data;
        }
      })
      .addCase(getCreditsHistory.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(getCreditsHistory.fulfilled, (state, action) => {
        const data = action.payload;
        state.credits = data;
        state.isLoading = false;
      })
      .addCase(fetchCarHouseById.fulfilled, (state, action) => {
        const data = action.payload.data;
        state.carHouse = data;
        state.isLoading = false;
      })
      .addCase(setCurrentPage, (state, action) => {
        state.currentPage = action.payload;
      })
      .addCase(setSearchParams, (state, action) => {
        state.searchParams = action.payload;
      });
  },
});

export const carHouseActions = {
  ...carHouseSlice.actions,
  setCurrentPage,
  setSearchParams,
};

export default carHouseSlice;
